import fetch from 'isomorphic-fetch'
import https from 'https'

export const REQUEST_USERVOICE_REQUEST_DATA = 'REQUEST_USERVOICE_REQUEST_DATA'
export const RECEIVE_USERVOICE_REQUEST_DATA = 'RECEIVE_USERVOICE_REQUEST_DATA'
export const INVALIDATE_USERVOICE_REQUEST_DATA = 'INVALIDATE_USERVOICE_REQUEST_DATA'

export function invalidateUserVoiceRequestData() {
  return {
    type: INVALIDATE_USERVOICE_REQUEST_DATA
  }
}

function requestData(){
  return{
    type: REQUEST_USERVOICE_REQUEST_DATA
  }
}

function receiveData(data, isActivityUser){
  return {
    type: RECEIVE_USERVOICE_REQUEST_DATA,
    data,
    isActivityUser,
    receivedAt: Date.now()
  }
}

function fetchData(option){
  return dispatch => {
    dispatch(requestData());

    return fetch('https://'+__API_HOST__+__USER_VOICE_REQUEST_URL__ + '?isValidUser=' + option.isActivityUser+ '&year=' + option.year)
      .then(response => response.json())
      .then( json => dispatch(receiveData(json.data, option.isActivityUser)) )

    // return fetch('api/collection/booking.json')
    //  .then(response => response.json())
    //  .then( json => dispatch(receiveData(json.data, isActivityUser)) )

  }
}

function shouldFetchData(state) {
  const userCard = state.usercardBooking;

  if (userCard.isFetching) {
    return false
  } else {
    return userCard.didInvalidate
  }
}

export function fetchDataIfNeeded(option) {

  return (dispatch, getState) => {
    // if (shouldFetchData(getState())) {
      return dispatch(fetchData(option))
    // }
  }
}



// WEBPACK FOOTER //
// ./src/actions/uservoice/requestAction.js